import moment from 'moment';
import * as React from 'react';
import * as H from 'history';
import { LOCAL_DATETIME_FORMAT } from '../../../../constants';
import ChoiceSelector, { Choice } from '../../../../widgets/ChoiceSelector';
import TimeSelectionDropdown from '../../../../widgets/TimeSelectionDropdown';
import { SetFilterValuesFunction } from '../../../FilterManager';
import {
  COMMON_DATA_FILTERS,
  getUrlDateRangeLocal,
  PORTAL_DATA_RANGE_DAYS,
} from '../data_constants';
import DataCustomDatetimeRange from './DataCustomDatetimeRange';

export type Props = {
  title: String;
  filters: URLSearchParams;
  history: H.History;
  choices: Choice[];
  onViewChange: (arg0: string) => void;
  setFilterValues: SetFilterValuesFunction;
  type: string;
};

export default class ViewTypeBar extends React.PureComponent<Props> {
  onChange = (start: moment.Moment, end: moment.Moment) => {
    const localRange = getUrlDateRangeLocal(
      start.toISOString(),
      end.toISOString(),
    );
    this.props.setFilterValues([
      { key: COMMON_DATA_FILTERS.START, value: localRange.start },
      { key: COMMON_DATA_FILTERS.END, value: localRange.end },
    ]);
  };

  render() {
    const { title, filters, choices, onViewChange, type } = this.props;
    const start = moment(
        filters.get(COMMON_DATA_FILTERS.START) || undefined,
        LOCAL_DATETIME_FORMAT,
      ),
      end = moment(
        filters.get(COMMON_DATA_FILTERS.END) || undefined,
        LOCAL_DATETIME_FORMAT,
      ),
      earliest = moment()
        .subtract(PORTAL_DATA_RANGE_DAYS - 1, 'days')
        .startOf('day');
    return (
      <div className="flex-row-wrap">
        <div className="pt-4">
          <h5 className="pb-2">{title}</h5>
          <ChoiceSelector
            choices={choices}
            onChange={onViewChange}
            currentValue={type}
            asRadioButtons={true}
            className="pt-1"
          />
        </div>

        <div className="pt-4">
          <h5 className="pb-2">Date/Time Range</h5>
          <TimeSelectionDropdown
            onChange={this.onChange}
            start={start}
            end={end}
            earliest={earliest}
            maxRangeDays={PORTAL_DATA_RANGE_DAYS}
            customRangeWidget={DataCustomDatetimeRange}
          />
        </div>
      </div>
    );
  }
}
